import { render } from "./EventConfigMenu.vue?vue&type=template&id=7b4db348&scoped=true"
import script from "./EventConfigMenu.vue?vue&type=script&lang=js"
export * from "./EventConfigMenu.vue?vue&type=script&lang=js"

import "./EventConfigMenu.vue?vue&type=style&index=0&id=7b4db348&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b4db348"

export default script